<template>
  <KioskAuthLayout :is-new="false"
                   :title="title"
                   :show-next-button="phoneValid"
                   :next-disabled="disableNextBtn"
                   show-back-button
                   @back="handleBack"
                   @next="handleNext">
    <div :class="$style.numberLookup">
      <p :class="$style.numberLookupText">{{ message }}</p>
      <Phone v-model="$v.phone.$model"
             :error="error"
             :disabled="disableNextBtn"/>

      <div :class="$style.moreBtnWrapper">
        <BaseButton :class="$style.moreBtn"
                    button-style="Back"
                    @click="handleButtonClick">
          {{ buttonText }}
        </BaseButton>

        <a v-if="savingPage"
           :class="$style.moreLink"
           @click="handleLearnMore">
          Learn More</a>
      </div>
    </div>
  </KioskAuthLayout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Action } from 'vuex-class';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import KioskAuthLayout from '@/layouts/KioskAuthLayout';
import BaseButton from '@/components/BaseButton';
import Phone from '@/apps/kiosk/components/Phone';
import { AUTH_KIOSK_TOKEN, AUTH_PROFILE, CHECK_CUSTOMER_PROFILE } from '@/apps/auth/store/types';

/* Provide number lookup screen */
@Component({
  components: {
    KioskAuthLayout,
    Phone,
    BaseButton,
  },
  props: {
    title: {
      type:    String,
      default: 'Phone Number',
    },
    message: {
      type:    String,
      default: 'Enter your phone number',
    },
    buttonText: {
      type:    String,
      default: 'Cancel',
    },
    buttonRoute: {
      type:     String,
      required: true,
    },
    savingPage: {
      type:    Boolean,
      default: false,
    },
  },
  validations: {
    phone: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
  },
})
export default class KioskNumberLookup extends Vue {
  @Action(AUTH_KIOSK_TOKEN) getKioskToken;
  @Action(CHECK_CUSTOMER_PROFILE) checkCustomer;
  @Action(AUTH_PROFILE) fetchProfile;

  phone = '';
  error = null;

  disableNextBtn = false;

  get phoneValid() {
    return this.$v.phone.$dirty && !this.$v.phone.$error;
  }

  handleBack() {
    this.$router.go(-1);
  }

  /**
   * Send phone and receive auth token with orders for passed phone
   */
  async handleNext() {
    try {
      this.disableNextBtn = true;

      const phone = `+1${this.phone}`;
      const isProfileExist = await this.checkCustomer({ phone });

      await this.getKioskToken({ phone });

      if (isProfileExist) {
        await this.fetchProfile();
      }

      this.$router.push({ name: 'auth-form' });
    } finally {
      this.disableNextBtn = false;
    }
  }

  handleButtonClick() {
    this.$router.push({ name: this.buttonRoute });
  }

  handleLearnMore() {
    this.$router.push({ name: 'past-info' });
  }
}
</script>

<style lang="scss" module>
@import '~@/style/variables.scss';

.numberLookupText {
  font-size: 34px;
  line-height: 48px;
  letter-spacing: 0.19px;
  text-align: center;
  margin: 42px 0 26px;
  padding: 0 50px;
}

.moreBtnWrapper {
  margin: 20px 0;
}

.numberLookup .moreBtnWrapper .moreBtn {
  width: 650px;
  height: 100px;
  margin: 0 auto;
  border-radius: 50px;
  border-width: 3px;
  div {
    font-size: 30px;
    line-height: 100px;
  }
}

.moreLink {
  display: block;
  margin-top: 20px;
  text-align: center;
  color: $links-color;
  font-size: 26px;
  line-height: 31px;
  font-weight: 300;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskNumberLookup.vue